import { Alert } from '@mui/material';

type NoDataErrorProps = {
  message?: string;
};

export const NoDataError = ({
  message = 'No data available.',
}: NoDataErrorProps) => {
  return (
    <Alert severity="info" sx={{ mt: 3 }}>
      {message}
    </Alert>
  );
};
